import * as React from 'react';
const ResetIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.005 3a7 7 0 0 1 6 3.39V4.15a.5.5 0 1 1 1 0v2.86a.89.89 0 0 1-.89.89h-2.86a.5.5 0 0 1 0-1h1.889A6 6 0 0 0 10.005 4a6 6 0 0 0-5.97 5.4.5.5 0 0 1-.995-.1A7 7 0 0 1 10.005 3m6.549 7.153a.5.5 0 0 1 .448.546 7 7 0 0 1-12.964 2.91v2.241a.5.5 0 1 1-1 0v-2.86a.89.89 0 0 1 .89-.89h2.86a.5.5 0 0 1 0 1h-1.89a6 6 0 0 0 11.109-2.5.5.5 0 0 1 .547-.447"
      fill="currentColor"
    />
  </svg>
);
export default ResetIcon;
